declare var require: any;

const msal: any = require("@azure/msal-browser/lib/msal-browser.min.js");

export const MsalConfig = {
  clientId: "350783a6-95c0-4626-98b3-ec7fe438e8f1",
  authority:
    "https://login.microsoftonline.com/739a9015-cb8c-411f-9270-0642862b97ce",
  redirectUri: "https://pms.swansol.net/"
};

export const MsalLoginRequest = {
  scopes: ["openid", "profile", "email"]
};

let app: any = null;

try {
  app = new msal.PublicClientApplication({
    auth: {
      clientId: MsalConfig.clientId,
      authority: MsalConfig.authority,
      redirectUri: MsalConfig.redirectUri
    },
    cache: {
      cacheLocation: "sessionStorage"
    }
  });
} catch (e) {
  console.error("MSAL init failed", e);
}

export function msalLoginPopup(): Promise<any> {
  if (!app) {
    return Promise.reject("MSAL is not initialized");
  }

  return app.loginPopup(MsalLoginRequest);
}

export function msalClearSession() {
  try {
    sessionStorage.clear();
  } catch (e) {}
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Services/msal.service.ts
 **/